import { PointExpirationSchedulePage } from './point-expiration-schedule.page';
import { usePointExpirationSchedule } from './use-point-expiration-schedule.hook';

type PointExpirationScheduleControllerProps = {
  memberId: string;
};

export const PointExpirationScheduleController = (
  props: PointExpirationScheduleControllerProps,
) => {
  const { memberId } = props;
  const {
    loading,
    error,
    data: pointExpirations,
    paginationProps,
  } = usePointExpirationSchedule({
    memberId,
  });

  return (
    <PointExpirationSchedulePage
      pointExpirations={pointExpirations}
      paginationProps={paginationProps}
      loading={loading}
      error={error}
    />
  );
};
